<template>
    <div class="col-sm-12 nopads mt-2">
        <div class="search-form p-2">
            <div class="col-12 span-header">
                1. {{ $t('daily_summary.choose_time') }}
            </div>
            <span class="pl-3 hint-text">{{ $t('contract_reports.trips_hint')}}</span>
            <div class=" row p-2">
                <div class="col-sm-6 nopads ">
                    <span class="span-title">{{ $t('trip_list.road_sec_from') }} - {{
                            $t('daily_summary.date')
                        }}</span>
                    <input
                        id="fromDate"
                        v-model="fromDate"
                        type="date"
                        class="form-control form-control-sm"
                        @blur="dateChanged"
                    />
                </div>
                <div class="col-sm-6 nopads pl-2 pr-1">
                    <span class="span-title">{{ $t('trip_list.road_sec_to') }} - {{
                            $t('daily_summary.date')
                        }}</span>
                    <input
                        id="date"
                        v-model="toDate"
                        type="date"
                        class="form-control form-control-sm"
                        @blur="dateChanged"
                    />
                </div>
            </div>
            <div class="col-12 span-header pt-2">
                2. {{ $t('daily_summary.choose_contract') }}
            </div>
            <div class="row nopads pr-1 pl-1 mr-1">
                <div class="col-sm-3 pl-2 pr-1">
                    <contract-contractors-filter
                        :contractIds="contractIds"
                        @contractorSet="setContractor"/>
                </div>
                <div class="col-8 nopads">
                    <open-contract-filter-multi-select
                        :to="paramToDate"
                        :from="paramFromDate"
                        :show-only-my-contracts-option="true"
                        :show-select-all-contracts-option="true"
                        :contract-collection="contractCollection"
                        :contract-disabled="!(contractNumber === '')"
                        :pre-selected-contract="preSelectedContract"
                        @loading="loading=true"
                        @loadingCompleted="loading=false"
                        @companySelected="setCompany"
                        @contractsSelected="setContracts"
                        @contractsFetched="setContractCollections"
                    />
                </div>
                <div class="col-4 nopads pl-2 hidden">
                    <span class="span-title">{{ $t('daily_summary.contract_number') }}</span>
                    <input
                        id="contractNumber"
                        v-model="contractNumber"
                        type="text"
                        class="form-control form-control-sm"
                    />
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-sm-3">
                    <span class="span-title">{{ $t('observations.contract_collection') }}</span>
                    <select
                        id="contractCollection"
                        v-model="contractCollection"
                        :disabled="!contractCollectionOptions || contractCollectionOptions.length === 0"
                        class="form-select form-select-sm"
                    >
                        <option :value="null">
                            {{ $t('trip_list.search_all') }}
                        </option>
                        <option
                            v-for="item in contractCollectionOptions"
                            :key="item.id"
                            :value="item"
                        >
                            {{ item.name }}
                        </option>
                    </select>
                </div>
                <!-- Constractor/subcontractor-->
                <div class="col-sm-3">
                    <contract-executors-filter
                        :contractIds="contractIds"
                        @executorSet="setExecutor"/>
                </div>
                <!-- Order-->
                <div class="col-sm-6">
                    <contract-order-multiselect
                        :contractIds="contractIds"
                        @ordersSelected="setOrders"
                        @noOrderSelected="setNoOrderSelected"
                        :no-order-option="true"
                    />
                </div>
            </div>
            <div class="row pb-2">
                <!-- Pricingmodel -->
                <div class="col-sm-6">
                    <pricing-model-filter
                        v-model="pricingModel"
                    />
                </div>
                <!-- Invoice state -->
                <div class="col-sm-6">
                    <invoice-state-filter
                        v-model="invoiceState"
                        :invoice-state-options="invoiceStateOptions"
                    />
                </div>
            </div>
            <div class="col-sm-12 button-container">
                <button
                    class="btn btn-primary"
                    :disabled="loading || (contractIds.length < 1 && !company && !contractNumber && !contractor)"
                    @click.stop="emitSearch"
                >
                    {{ $t('common.search') }}
                </button>
            </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {restApi} from '../mixins/RestApiMixin'
import {orderMixin} from "../mixins/OrderMixin";
import {contractHelper} from "@/components/mixins/ContractMixin";
import ContractContractorsFilter from "@/components/contract/ContractContractorsFilter";
import ContractExecutorsFilter from "../contract/ContractExecutorsFilter";
import ContractOrderMultiselect from "../order/ContractOrderMultiselect";
import PricingModelFilter from "../pricingmodels/PricingModelFilter";
import InvoiceStateFilter from "../invoice/InvoiceStateFilter";
import OpenContractFilterMultiSelect from "../contract/OpenContractFilterMultiSelect";

export default {
    name: 'contract-trip-summary-filter',
    components: {
        OpenContractFilterMultiSelect, ContractContractorsFilter,
        PricingModelFilter, ContractOrderMultiselect, ContractExecutorsFilter, InvoiceStateFilter},
    mixins: [timeUtils, restApi, orderMixin, contractHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
        invoiceStateOptions: {
            type: Array,
            default() {
                return []
            }
        },
        preSelectedContract: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            fromDate: null,
            toDate: null,
            paramFromDate: null,
            paramToDate: null,
            pricingModel: null,
            withoutOrder: false,
            contractNumber: '',
            invoiceState: null,
            company: null,
            contracts: [],
            executor: null,
            contractor: null,
            contractIds: [],
            order: null,
            contractCollection: null,
            contractCollectionOptions: [],
            orders: [],
            searchFrom: null,
            searchTo: null,
            companies: []
        }
    },
    mounted: function () {
        this.fromDate = this.getYesterday()
        this.toDate = this.getYesterday()
        this.paramFromDate = this.fromDate
        this.paramToDate = this.toDate
        if (this.preSelectedContract) {
            this.contractIds.push(this.preSelectedContract)
        }
    },
    methods: {
        emitSearch: function () {
            let orderParams = []
            if (this.orders) {
                this.orders.forEach(order => orderParams.push(order.id))
            }
            if ((this.contractIds.length > 0 || this.company || this.contractor || this.contractNumber) && this.toDate && this.fromDate) {
                this.$emit('search', {
                        to: this.toDate,
                        from: this.fromDate,
                        contractIds: this.contractIds && this.contractIds.length > 0 ? this.contractIds : undefined,
                        executor: this.executor ? this.executor.id : undefined,
                        contractor: this.contractor ? this.contractor.id : undefined,
                        orders: orderParams.length > 0 ? orderParams : undefined,
                        customer: this.company ? this.company.id : undefined,
                        contractNumber: !(this.contractNumber === '') ? this.contractNumber : undefined,
                        pricingModel: this.pricingModel ? this.pricingModel.id : undefined,
                        invoiceState: this.invoiceState && this.invoiceState.value >= 0 ? this.invoiceState.value : undefined,
                        orderDetails: 1,
                        withoutOrder: this.withoutOrder ? 1 : undefined,
                    },
                    this.company ? this.company.name : undefined,
                    this.executor ? this.executor.name : undefined,
                    this.contracts ? this.getSelectedAreaGroupNames() : undefined,
                    this.contracts ? this.getSelectedContractNames() : undefined,
                    this.orders ? this.getSelectedOrderNames() : undefined,
                )
                this.searchFrom = this.fromDate
                this.searchTo = this.toDate
            }
        },
        getYesterday: function () {
            let d = new Date();
            d.setDate(d.getDate() - 1)
            let month = d.getMonth() + 1
            if (month < 10) {
                month = '0' + month;
            }
            let day = d.getDate()
            if (day < 10) {
                day = '0' + day;
            }
            return d.getFullYear() + '-' + month + '-' + day
        },
        setContracts: function (contracts) {
            this.contracts = contracts
            this.contractIds = []
            contracts.map(contract => {
                this.contractIds.push(contract.id)
            })
        },
        setOrders(orders) {
            this.orders = orders
        },
        setCompany: function (company) {
            this.company = company
        },
        setExecutor: function (executor) {
            this.executor = executor
        },
        setContractor: function (contractor) {
            this.contractor = contractor
        },
        setNoOrderSelected(status) {
            this.withoutOrder = status
        },
        dateChanged: function () {
            this.paramFromDate = this.fromDate
            this.paramToDate = this.toDate
        },
        getSelectedContractNames: function () {
            let text = ''
            this.contracts.forEach(contract => {
                if (text.length > 0) {
                    text += ', '
                }
                text += contract.name
            })
            return text
        },
        getSelectedOrderNames: function () {
            let text = ''
            this.orders.forEach(order => {
                if (text.length > 0) {
                    text += ', '
                }
                text += this.getOrderAndExecutorStr(order)
            })
            return text
        },
        getSelectedAreaGroupNames: function () {
            let text = ''
            this.contracts.forEach(contract => {
                if (text.length > 0) {
                    text += ', '
                }
                text += contract.area_group ? contract.area_group.name : ''
            })
            return text
        }
    }
}
</script>
